import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './referral-code.reducer';

export const ReferralCodeDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const referralCodeEntity = useAppSelector(state => state.referralCode.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="referralCodeDetailsHeading">
          <Translate contentKey="fivePlusApp.referralCode.detail.title">ReferralCode</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{referralCodeEntity.id}</dd>
          <dt>
            <span id="referralCode">
              <Translate contentKey="fivePlusApp.referralCode.referralCode">Referral Code</Translate>
            </span>
          </dt>
          <dd>{referralCodeEntity.referralCode}</dd>
          <dt>
            <Translate contentKey="fivePlusApp.referralCode.user">User</Translate>
          </dt>
          <dd>{referralCodeEntity.user ? referralCodeEntity.user.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/referral-code" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/referral-code/${referralCodeEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default ReferralCodeDetail;
